import * as actionType from '../constants/constant.action'

export interface GetReferralMemberState {
  requestMade: boolean
  responseReceived: boolean
  failureResponse?: any
  successResponse?: any
}

const defaultState: GetReferralMemberState = {
  requestMade: false,
  responseReceived: false,
  failureResponse: undefined,
  successResponse: undefined,
}

const getReferralMemberReducer = (
  state = defaultState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case actionType.GET_REFERRAL_MEMBER_REQUEST:
      return {
        ...state,
        requestMade: true,
      }
    case actionType.GET_REFERRAL_MEMBER_FAILURE:
      return {
        ...state,
        failureResponse: action.payload,
        successResponse: undefined,
        responseReceived: true,
      }
    case actionType.GET_REFERRAL_MEMBER_SUCCESS:
      return {
        ...state,
        failureResponse: undefined,
        successResponse: action.payload,
        responseReceived: true,
      }
    default:
      return state
  }
}

export default getReferralMemberReducer
